import Image from "next/image";
import dynamic from "next/dynamic";
import { Play } from "lucide-react";

import { Paragraph } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";

import { cn } from "@/lib/utils";

const StudyIQLogo = dynamic(() => import("../vectors/studyiq-logo.svg"));

function DemoVideo({ video, onPlayClick = () => null }) {
  return (
    <div className="flex flex-col bg-grayscale-weak border border-grayscale-input rounded-xl overflow-hidden">
      <div className="relative flex items-center justify-center h-40 w-75">
        <StudyIQLogo />
        <Image src={video.thumbnail} alt={video.title} className="z-10" fill />
      </div>

      <div
        className={cn(
          "flex items-center justify-between gap-x-4 py-4 px-5 -mt-3",
          "rounded-t-xl bg-primary-foreground z-20"
        )}
      >
        <Paragraph
          variant="b2-tight"
          weight="sb"
          className="line-clamp-1 text-grayscale-header-weak"
        >
          {video.title}
        </Paragraph>

        <Button
          size="icon"
          className="!bg-grayscale-input !text-grayscale-label rounded-full size-6"
          onClick={onPlayClick}
        >
          <Play className="size-2.5" fill="currentColor" />
        </Button>
      </div>
    </div>
  );
}

export default DemoVideo;
